import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { apiPatch } from '@src/services/api/helpers';

import {
    Button,
    useRecordContext,
} from 'react-admin';

const PremierAccessButton = (props) => {
    const recordContext = useRecordContext();
    const user = props.user || recordContext;
    const [premierAccess, setPremierAccess] = useState(user?.premier_access);
    const [prevUserId, setPrevUserId] = useState(user?.id);

    if (user?.id !== prevUserId) {
        setPrevUserId(user?.id);
        setPremierAccess(user?.premier_access);
    }

    const handleGrantAccessButtonClick = () => {
        if (!user?.id) {
            return;
        }

        apiPatch(`/users/${user.id}/grant_premier_access`).then(() => {
            setPremierAccess(true);
        }).catch((error) => {
            console.error(error);
        });
    };

    const handleRevokeAccessButtonClick = () => {
        if (!user?.id) {
            return;
        }

        apiPatch(`/users/${user.id}/revoke_premier_access`).then(() => {
            setPremierAccess(false);
        }).catch((error) => {
            console.error(error);
        });
    };

    if (!user || !user.id) {
        return null;
    }

    if (premierAccess) {
        return (
            <Button
                label="Revoke Premier Access"
                onClick={handleRevokeAccessButtonClick}
            />
        );
    }

    return (
        <Button
            label="Grant Premier Access"
            onClick={handleGrantAccessButtonClick}
        />
    );
};

PremierAccessButton.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        premier_access: PropTypes.bool,
    }),
};

export default PremierAccessButton;
